import React from "react";
import { Tooltip } from "@mui/material";
import "./components.css";
import { useTranslation } from "react-i18next";

function InfoTextComponent(props) {
    const {title, text, example, points} = props;
    const {t} = useTranslation();
    return (
        <div className="infoText" style={{ width: "100%", background: "#fbfcd3" }}>
            <span className="infoTextTitle">
                <Tooltip arrow>
                    <span className="infoIcon">i</span>
                </Tooltip>
                {t(title)}</span>
            <div className="infoTextContent">{t(text)}</div>
            <span className="infoExample">{t(example)}</span>
            <ul className="infoList">
                {points?.map((point, index) => (
                    <li key={index}>{t(point)}</li>
                ))}
            </ul>
        </div>
    );
}

export default InfoTextComponent;
